import { isGitHubAppTrustedFlow } from "~/areas/configuration/components/Git/getGitHubAppSettings";

export function beginGitHubAppRedirectFlow(url: string) {
    if (isGitHubAppTrustedFlow()) {
        window.location.assign(url);
    } else {
        window.open(url, "_blank");
    }
}
